import { basename } from 'path';

import { hashString } from '@zapier/design-system';

// Creates a unique BEM-style `className` based on the supplied
// arguments. To avoid collisions the full `filepath` should be
// supplied via `__filename` to differentiate files with the same name.
const createUniqueClassName = (filepath: string, elementName: string) => {
  const hash = hashString(filepath);
  const filename = basename(filepath).split('.')[0];
  return `${filename}__${elementName}-${Math.abs(hash)}`;
};

export default createUniqueClassName;
